function hasInvalidDots(part: string): boolean {
    return part.startsWith('.') || part.endsWith('.') || part.includes('..');
}

function isValidInviteDomain(domain: string): boolean {
    if (hasInvalidDots(domain) || !domain.includes('.')) return false;
    if (!/^[a-zA-Z0-9.-]+$/.test(domain)) return false;
    return domain.split('.').every((label) => label.length > 0 && !label.startsWith('-') && !label.endsWith('-'));
}

/** Basic check that an invite email is sendable (rejects trailing-dot domains, etc.). */
export function isValidInviteEmail(raw: string): boolean {
    const email = raw.trim();
    if (!email || email.includes(' ') || email.includes(',')) return false;

    const at = email.indexOf('@');
    if (at <= 0 || at !== email.lastIndexOf('@')) return false;

    const local = email.slice(0, at);
    const domain = email.slice(at + 1);
    if (!local || !domain) return false;
    if (hasInvalidDots(local) || !isValidInviteDomain(domain)) return false;

    return true;
}
